import styled from 'styled-components';

export const Container = styled.div`
	height: 100vh;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	background: ${props => props.theme.background};
	display: flex;
	flex-direction: column;
	${'' /* padding-top: 50px; */}
`;

export const Content = styled.div`
	flex: 1;
	padding: 16px;
	display: flex;
	flex-direction: column;
`;

export const Title = styled.h1`
	font-size: 24px;
	font-weight: 700;
	color: ${props => props.theme.text.primary};
	text-align: center;
	margin: 0 0 16px 0;
`;

export const Subtitle = styled.p`
	font-size: 16px;
	color: ${props => props.theme.text.secondary};
	text-align: center;
	margin: 0 0 32px;
`;

export const TokenIcon = styled.div`
	font-size: 64px;
	text-align: center;
	margin-bottom: 32px;
`;

export const Terms = styled.p`
	font-size: 13px;
	color: ${props => props.theme.text.secondary};
	text-align: center;
	margin-top: 32px;
`; 